import { render, staticRenderFns } from "./extend.vue?vue&type=template&id=347c63fa&"
import script from "./extend.vue?vue&type=script&lang=js&"
export * from "./extend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports